"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStoreProducts = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _ShopActionTypes = require("../constants/action-types/ShopActionTypes");

var metaTypes = _interopRequireWildcard(_ShopActionTypes);

var _requests = require("../libs/utils/requests");

var _config = require("../config");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var retrievingStore = function retrievingStore() {
  return {
    type: metaTypes.RETRIEVING_STORE
  };
};

var getStoreProductsSuccess = function getStoreProductsSuccess(payload) {
  return {
    type: metaTypes.GET_STORE_PRODUCTS_SUCCESS,
    payload: payload
  };
};

var getStoreProductsFailure = function getStoreProductsFailure(_ref) {
  var error = _ref.error;
  return {
    type: metaTypes.GET_STORE_PRODUCTS_FAILURE,
    payload: error
  };
};

var getStoreProducts = exports.getStoreProducts = function getStoreProducts(_ref2) {
  var token = _ref2.token;
  var fetchOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    }
  };
  return function (dispatch) {
    dispatch(retrievingStore());
    return (0, _requests.sendRequest)({
      destination: _config2.default.serviceUrls.api.shop,
      dispatch: dispatch,
      options: fetchOptions
    }, function (_ref3) {
      var products = _ref3.payload;
      console.log("products", products);
      var productRequests = products.map(function (product) {
        return getProductRequest({
          token: token,
          id: product.id
        });
      });
      return Promise.all(productRequests).then(function (products) {
        console.log("product responses", products);
        var variantMap = products.map(function (item) {
          return item.variants;
        }).map(function (variants) {
          console.log("v", variants);
          return variants.reduce(function (acc, _ref4) {
            var size = _ref4.size,
                color = _ref4.color;
            return {
              sizes: _extends({}, acc.sizes, _defineProperty({}, size, true)),
              colors: _extends({}, acc.colors, _defineProperty({}, color, true))
            };
          }, {
            sizes: {},
            colors: {}
          });
        });
        console.log("VM", variantMap);
        dispatch(getStoreProductsSuccess({
          products: products,
          variantMap: variantMap
        }));
      });
    }).catch(function (err) {
      return dispatch(getStoreProductsFailure({
        error: err
      }));
    });
  };
};

var getProductRequest = function getProductRequest(_ref5) {
  var token = _ref5.token,
      id = _ref5.id;
  console.log("id", id);
  var fetchOptions = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token
    }
  };
  return (0, _requests.sendRequest2)({
    destination: _config2.default.serviceUrls.api.shop + "/" + id,
    options: fetchOptions
  }).then(function (info) {
    console.log(info);
    return info.payload;
  });
};